import { FiUsers, FiBook, FiClipboard, FiBarChart2 } from "react-icons/fi";

const ManagerDashboard = () => {
  const cards = [
    {
      id: 1,
      title: "Total Projects",
      value: 24,
      icon: <FiClipboard className="text-xl" />,
    },
    {
      id: 2,
      title: "Published Papers",
      value: 12,
      icon: <FiBook className="text-xl" />,
    },
    {
      id: 3,
      title: "Team Members",
      value: 8,
      icon: <FiUsers className="text-xl" />,
    },
    {
      id: 4,
      title: "Ongoing Research",
      value: 5,
      icon: <FiBarChart2 className="text-xl" />,
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {cards.map((card) => (
        <div
          key={card.id}
          className="flex items-center min-h-[100px] p-4 bg-white border border-gray-200 rounded-xl hover:border-gray-300 transition-all"
        >
          <div className="w-12 h-12 bg-[#e8f0f7] rounded-lg flex items-center justify-center flex-shrink-0">
            <div className="text-[#0f6abf]">
              {card.icon}
            </div>
          </div>
          <div className="ml-4">
            <h1 className="text-sm font-medium text-gray-600">{card.title}</h1>
            <p className="text-xl font-semibold text-gray-900">{card.value}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ManagerDashboard;